import store from "~/state/store";
import GeneralStoreFactory from '~/state/generalStoreFactory'
import processFlowSubmissionStoreFactory from "./modules/processFlowSubmissionStoreFactory";
import {IProcessFlow} from '~/interfaces/processFlowInterfaces'

export default class StoreFactory extends GeneralStoreFactory {
  static registerModules(processFlow: IProcessFlow) {
    store.registerModule('processFlowSubmissionStore', processFlowSubmissionStoreFactory(processFlow));
  }
}